import React from "react";
import { IonButton, IonTextarea } from "@ionic/react";
import { Controller, useForm } from "react-hook-form";
import CommonModal from "../UI/CommonModal/CommonModal";
import StarRating from "../UI/StarRating/StarRating";
import CommonFormElement from "../UI/CommonFormElements/CommonFormElement";

import classNames from "classnames/bind";

import styles from "./OrderReview.module.scss";
import useAddReviewSetOrder from "../../providers/Orders/useAddReviewSetOrder";
import { OrderReviewType } from "@core/types";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

export interface OrderReviewProps {
  orderNumber: string;
  onDismiss: () => void;
}

const OrderReview = ({ onDismiss, orderNumber }: OrderReviewProps) => {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
  });

  const { mutate: addReviewOrder } = useAddReviewSetOrder(orderNumber);

  const handleFSubmit = async ({ customerNote, productQuality }: any) => {
    const reviewData: OrderReviewType = {
      customerNote,
      productQuality,
      deliverySpeed: productQuality,
      driverCourtesy: productQuality,
      assemblyQuality: productQuality,
      orderId: orderNumber,
    };

    addReviewOrder(reviewData);

    onDismiss();
  };

  const areaPlaceholder = t(
    "Please rate the service and leave any comments or feedback that can help us make it better. The main criteria include the quality of the products, speed of delivery, courtesy of the delivery person and the fact of delivery to the door. Your feedback is very important to us!",
  );

  return (
    <CommonModal onDismiss={onDismiss} title={t("Order review")}>
      <form className="h-full" onSubmit={handleSubmit(handleFSubmit)}>
        <div className="flex flex-col justify-between h-full relative">
          <div className={cx("rateWrapper")}>
            <Controller
              name="productQuality"
              control={control}
              rules={{
                required: t("Needed to evaluate the order"),
              }}
              render={({ field: { onChange, value } }) => {
                return (
                  <CommonFormElement
                    commonLabelClassName="!p-0"
                    label={t("Rate the order")}
                    isValid={value !== 0 && value !== undefined}
                    errorMessage={errors.productQuality?.message}
                  >
                    <StarRating onChange={onChange} value={value} />
                  </CommonFormElement>
                );
              }}
            />
            <Controller
              name="customerNote"
              control={control}
              rules={{
                required: t("Required field"),
              }}
              render={({ field: { onChange, value } }) => {
                return (
                  <CommonFormElement
                    commonLabelClassName="!p-0"
                    classListItem={cx("textAreaCommon", "mb-0")}
                    label={t("Order comment")}
                    isValid={value?.length > 0}
                    errorMessage={errors.customerNote?.message}
                  >
                    <IonTextarea
                      inputMode="text"
                      value={value}
                      placeholder={areaPlaceholder}
                      className={cx("textArea", "px-4 py-2 text-sm rounded-3xl")}
                      onIonChange={(e) => onChange(e.detail.value!)}
                    />
                  </CommonFormElement>
                );
              }}
            />
          </div>

          <IonButton
            mode="ios"
            type="submit"
            expand="block"
            color="primary"
            className=""
            // className='fixed w-[98%] ml-1 left-0 bottom-1 pl-[1.65rem] pr-[1.35rem] '
          >
            {t("Send")}
          </IonButton>
        </div>
      </form>
    </CommonModal>
  );
};

export default OrderReview;
